module.exports = "https://tutorchat.chegg.com/static/media/ic-text.6659895a.svg";